import AccountingView from "@/accounting/views/AccountingView.vue";
import CollectionView from "@/accounting/views/CollectionView.vue";
import AccountingExportView from "@/accounting/views/AccountingExportView.vue";
import AccountingPurchaseView from "@/accounting/views/AccountingPurchaseView.vue";
import AccountingDisbursementView from "@/accounting/views/AccountingDisbursementView.vue";
import ProfessionalListView from "@/accounting/views/ProfessionalListView.vue";

export const accountingRoutes = [
  {
    path: "/accounting",
    name: "Accounting",
    component: AccountingView,
  },
  {
    path: "/collections",
    name: "CollectionView",
    component: CollectionView,
  },
  {
    path: "/accounting-purchases",
    name: "AccountingPurchaseView",
    component: AccountingPurchaseView,
  },
  {
    path: "/accounting-disbursements",
    name: "AccountingDisbursementView",
    component: AccountingDisbursementView,
  },
  {
    path: "/accounting-export",
    name: "AccountingExportView",
    component: AccountingExportView,
  },
  {
    path: "/professionals",
    name: "ProfessionalList",
    component: ProfessionalListView,
  },
];
